import { $$ } from '../lib/dom';
import { initForm } from './forms/form-controller';
import { initFlows } from './motion/flow-gradient';
import { initHeroPanel } from './motion/hero-panel-animation';
import { initMarquee } from './motion/marquee';
import { initOffscreenPause, initReveal } from './motion/reveal';
import { initAccordion } from './ui/accordion';
import { initCopyButtons } from './ui/copy-link';
import { initVideo } from './video/platform-video';

/** Behaviour shared by every page, attached after each render. */
export function initPageBehaviors(root: HTMLElement): void {
  initReveal(root);
  initOffscreenPause(root);
  initFlows(root);
  initHeroPanel(root);
  initVideo(root);
  initMarquee(root);
  $$('[data-accordion]', root).forEach(initAccordion);
  $$('form[data-form]', root, HTMLFormElement).forEach(initForm);
  initCopyButtons(root);
}
